import {Injectable} from '@angular/core';

export interface Menu {
    state: string;
    name: string;
    type: string;
    icon: string;
}

@Injectable()
export class MenuItems {
    dummyMenu: Menu = {state: '', type: '', name: '', icon: ''};
    MENU_ITEMS = [
        {state: 'dashboard', type: 'link', name: 'Dashboard', icon: 'fact_check'},
        // Hidden from nav — the Dashboard now covers Test Cases (browse/counts/drill-in).
        // Route still exists (templates.routing) so deep links keep working; re-add to restore.
        // {state: 'templates', type: 'link', name: 'Test Cases', icon: 'build'},
        {state: '', type: 'header', name: 'Authoring', icon: ''},
        {state: 'studio', type: 'link', name: 'Test Studio', icon: 'travel_explore'},
        {state: 'suite', type: 'link', name: 'Auto-Suite (UI)', icon: 'auto_awesome_motion'},
        {state: 'api-suite', type: 'link', name: 'API Suite', icon: 'api'},
        {state: '', type: 'header', name: 'Operations', icon: ''},
        {state: 'schedule', type: 'link', name: 'Schedule', icon: 'settings'},
        {state: 'runs', type: 'link', name: 'Reports', icon: 'summarize'},
        {state: 'settings', name: 'Settings', type: 'link', icon: 'tune'},
        this.dummyMenu,
    ];

    getMenuitem(): Menu[] {
        return this.MENU_ITEMS.filter(menuItem => menuItem.type === 'link' || menuItem.type === 'header');
    }
}
